module.exports = __webpack_public_path__ + "img/login-logo.c114ef1c.png";